// extracted by mini-css-extract-plugin
export default {"description":"sended-sign-modal_description__u+zpf","imageWrap":"sended-sign-modal_imageWrap__Pj0Id","modalButton":"sended-sign-modal_modalButton__M8882"};